// axios
import axios from 'axios'
import router from '../router'

// const apiURL = 'http://3.37.140.239:6180/api'
// const apiURL = 'http://218.154.39.97:8081/api/v2'
const apiURL = `${process.env.REACT_APP_API_URL}/api/v2`
// const apiURL = 'http://192.168.21.237:8081/api/v2'

const axiosIns = axios.create({
    baseURL: apiURL,
    withCredentials: false,
    responseType: 'json'
})

axiosIns.interceptors.request.use(
    async config => {
        const accessToken = localStorage.getItem('accessToken')
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }

        //Admin인 경우에는 Header를 포함하지 않음.
        if(!window.location.href.includes('/admin')) {
            const isDemoMode = localStorage.getItem('demoMode');
            if(isDemoMode) {
                config.headers['X-Demo-Mode'] = isDemoMode;
            }
        }

        return config
    },
    error => {
        console.log(error)
        Promise.reject(error)
    },
)

axiosIns.interceptors.response.use( 
    (response) => {
        return response.data
    },
    async error => {
        const { response, config } = error
        if (response) {
            switch(response.data.code) {
                case 1001:
                    // 권한 만료인 경우가 아닐 떄.
                    if (response.status !== 401) {
                        break;
                    }
                    try {
                        const originalRequest = config
                        const refreshToken = localStorage.getItem('refreshToken')
                        const res = await axios.post(`${apiURL}/auth/refresh`, { refreshToken })
                        if (res.status != '200') throw res.status
                        const resData = res.data
                        localStorage.setItem('AdmincmsUserId', resData.data.cmsUserId)
                        localStorage.setItem('cmsUserId', resData.data.cmsUserId)
                        localStorage.setItem('accessToken', resData.data.token)
                        localStorage.setItem('refreshToken', resData.data.refreshToken)
                        return axiosIns(originalRequest)
                    } catch (err) {
                        localStorage.removeItem('AdmincmsUserId')
                        localStorage.removeItem('cmsUserId')
                        localStorage.removeItem('accessToken')
                        localStorage.removeItem('refreshToken')
                        localStorage.removeItem('lang')
                        localStorage.setItem('serverError', 'SESSION')
                        //만약에 현재 페이지가 어드민 페이지였다면 로그인 페이지를 어드민 로그인으로 보내자.
                        if(window.location.href.includes('/admin')) {
                            router.navigate('/admin')
                        }else{
                            router.navigate('/')
                        }
                    }
                    break
                default:
                    break;  
            }
            return Promise.reject({
                ...response.data,
                status: response.status,  // HTTP 상태 코드 포함
            })
            //return Promise.reject(response.data)
        }

        return Promise.reject(error)
    },
)

export default axiosIns
